import { z } from 'zod'

export const createSchemas = (formatMessage) => {
  const emailSchema = z
    .string()
    .nonempty(formatMessage({ id: 'login_email_empty' }))
    .email(
      formatMessage({ id: 'invalid_email' })
    )

  const passwordSchema = z
    .string()
    .nonempty(formatMessage({ id: 'login_password_empty' }))

  const twoFaCodeSchema = z.string().nonempty()

  const loginFormSchema = z.object({
    email: emailSchema,
    password: passwordSchema
  })

  const twoFaFormSchema = z.object({
    twoFaCode: twoFaCodeSchema
  })

  const resetPasswordFormSchema = z.object({
    email: emailSchema
  })

  return {
    loginFormSchema,
    twoFaFormSchema,
    resetPasswordFormSchema,
    emailSchema,
    passwordSchema,
    twoFaCodeSchema
  }
}
